import { Controller } from "@hotwired/stimulus"
import { sendAnalyticsEvent } from "../../lib/analytics_beacon"

// How much of an item was consumed, as the quarter milestones a player or PDF
// flipbook inside this element passes. It sits on the reader root and listens
// in the capture phase, because `timeupdate` does not bubble and the players
// below it are shared components that know nothing about analytics. Each
// media element reports each milestone once per page.
const MILESTONES = [25, 50, 75, 100]

export default class extends Controller {
  static values = { subjectType: String, subjectId: String }

  connect() {
    if (!this.subjectTypeValue || !this.subjectIdValue) return

    this.reported = new WeakMap()
    this.onTimeUpdate = event => this.trackPlayback(event.target)
    this.onPageChanged = event => this.trackPages(event.detail)
    this.element.addEventListener("timeupdate", this.onTimeUpdate, true)
    this.element.addEventListener("ended", this.onTimeUpdate, true)
    this.element.addEventListener("pdf-flipbook:page-changed", this.onPageChanged)
  }

  disconnect() {
    this.element.removeEventListener("timeupdate", this.onTimeUpdate, true)
    this.element.removeEventListener("ended", this.onTimeUpdate, true)
    this.element.removeEventListener("pdf-flipbook:page-changed", this.onPageChanged)
  }

  trackPlayback(media) {
    if (!(media instanceof HTMLMediaElement) || !(media.duration > 0)) return

    const percent = media.ended ? 100 : (media.currentTime / media.duration) * 100
    this.report(media, percent)
  }

  trackPages(detail) {
    if (!detail || !(detail.total > 0)) return

    const page = detail.rightPage || detail.page
    this.report(this.element, (page / detail.total) * 100)
  }

  report(source, percent) {
    const done = this.reported.get(source) || new Set()
    MILESTONES.filter(milestone => percent >= milestone && !done.has(milestone)).forEach(milestone => {
      done.add(milestone)
      sendAnalyticsEvent("content_progress", {
        subjectType: this.subjectTypeValue,
        subjectId: this.subjectIdValue,
        properties: { completion_percent: milestone, content_type: this.subjectTypeValue }
      })
    })
    this.reported.set(source, done)
  }
}
